import { useEffect } from 'react';

/**
 * Custom hook to set the page title
 * @param title - The page title without the app name suffix
 */
export const usePageTitle = (title: string) => {
  useEffect(() => {
    // Set the document title with the CYNAYD Drive suffix
    document.title = `${title} - CYNAYD Drive`;
    
    // Cleanup function to reset to default title when component unmounts
    return () => {
      document.title = 'CYNAYD Drive';
    };
  }, [title]);
};

export default usePageTitle;

